import React from 'react';

export default function SectionHeader({ num, title, titleEm, body }) {
  return (
    <div style={{ marginBottom: 32 }}>
      <div style={{
        fontSize: 11, fontWeight: 600, letterSpacing: 3,
        textTransform: 'uppercase', color: 'var(--g2)',
        marginBottom: 8, display: 'flex', alignItems: 'center', gap: 10,
      }}>
        {num}
        <span style={{ flex: 1, height: 1, background: '#D1D5DB', maxWidth: 60 }} />
      </div>
      <h2 style={{
        fontFamily: 'var(--serif)',
        fontSize: 'clamp(26px, 3vw, 36px)',
        color: 'var(--ink)', lineHeight: 1.15,
        letterSpacing: '-0.5px', marginBottom: 16,
        fontWeight: 600,
      }}>
        {title}{' '}
        {titleEm && <em style={{ color: 'var(--g2)', fontStyle: 'italic' }}>{titleEm}</em>}
      </h2>
      {body && (
        <p style={{ fontSize: 15, color: 'var(--gray)', lineHeight: 1.8, maxWidth: 620, marginBottom: 0 }}>
          {body}
        </p>
      )}
    </div>
  );
}
